<div class="mb-4 input-group">
    <input type="text"
           [(ngModel)]="selectedDescriptorName"
           [typeaheadAsync]="true"
           [wsTypeahead]="dataSource"
           (typeaheadLoading)="changeTypeaheadLoading($event)"
           [typeaheadScrollable]="true"
           [typeaheadOptionsInScrollableView]="10"
           placeholder="Add Characteristic"
           (typeaheadOnSelect)="descriptorSelected($event.item)"
           [typeaheadMinLength]="2"
           typeaheadOptionField="typeaheadField"
           [typeaheadOptionsLimit]="20"
           [disabled]="disabled"
           class="form-control">
    @if (typeaheadLoading) {
        <i class="fa fa-spinner fa-pulse form-control-feedback"></i>
    }
    <button type="button" class="ace-btn has-icon btn-secondary" (click)="this.openBrowseModal()" [disabled]="disabled">
        <i class="fa fa-binoculars"></i>
    </button>
</div>
